import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CryptoService} from './crypto.service';
export const STORE_KEY_SmartReportType = 'srt'; // smart power report type
export const STORE_KEY_LoadDistributionDevice = 'lddn'; // Click Load Distribution Device Link to status log
export const STORE_KEY_CheckReport = 'check_report'; // Check Report Web

@Injectable({
  providedIn: 'root'
})
export class SmartPowerReportService {
  SmartReportType: number;
  LoadDistributionDevice: number;
  CheckReport: number;

  constructor(private http: HttpClient, private cryptoService: CryptoService) { }

  ReadSmartPowerReportList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/report/smart/list`, params);
  }

  ReadSmartPowerReport(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/report/smart/read`, params);
  }

  ReadSmartPowerReportData(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/report/smart/data/read`, params);
  }

  UpdateSmartPowerReport(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/smartpower/report/update`, params);
  }

  DeleteSmartPowerReport(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/smartpower/report/delete`, params);
  }

  set SetSmartReportType(value) {
    localStorage.setItem(STORE_KEY_SmartReportType, value);
    this.SmartReportType = value;
  }

  get GetSmartReportType() {
    const data = localStorage.getItem(STORE_KEY_SmartReportType);
    return data === null ? null : Number(data);
  }

  set SetLoadDistributionDevice(value) {
    localStorage.setItem(STORE_KEY_LoadDistributionDevice, value);
    this.LoadDistributionDevice = value;
  }

  get GetLoadDistributionDevice() {
    const data = localStorage.getItem(STORE_KEY_LoadDistributionDevice);
    return data === null ? null : Number(data);
  }

  set SetCheckReport(value) {
    localStorage.setItem(STORE_KEY_CheckReport, value);
    this.CheckReport = value;
  }

  get GetCheckReport() {
    const data = localStorage.getItem(STORE_KEY_CheckReport);
    return data === null ? null : data;
  }
}
